module.exports = __webpack_public_path__ + "img/3.cd49f32e.webp";